import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  createDialog,
  DialogCloseAction,
  DialogCommand,
  DialogResponse,
  GalaxyDialogService,
  STANDARD_DIALOG_ID
} from '@ebcont/ebcont.galaxy.js';
import { Subscription } from 'rxjs';

@Component({
  selector: 'hoc-profile-download',
  templateUrl: './hoc-profile-download.component.html',
  styleUrls: ['./hoc-profile-download.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HocProfileDownloadComponent implements OnInit {
  @ViewChild('footer') footer: TemplateRef<unknown> | undefined;
  @ViewChild('content') content: TemplateRef<unknown> | undefined;
  @ViewChild('header') header: TemplateRef<unknown> | undefined;

  @Input() email?: string;
  private commandId = '';
  private commandSubscription: Subscription | undefined;

  constructor(private service: GalaxyDialogService) {}

  ngOnInit(): void {
    this.commandSubscription = this.service.command$.subscribe({
      next: (value: DialogCommand) => {
        if (value.dialogId === 'profileDownload') {
          if (value.command === 'open') {
            this.commandId = this.service.add(
              createDialog({
                ...value.options,
                footer: this.footer,
                content: this.content,
                header: this.header
              }),
              STANDARD_DIALOG_ID
            );
            console.log(this.commandId + ' opened');
          }
        }
      }
    });

    this.service.response$.subscribe((response: DialogResponse) => {
      if (response.commandId === this.commandId) {
        console.log(`Dialog closed with commandId: ${response.commandId}, response:`, response.response);
      }
    });
  }

  ngOnDestroy() {
    if (this.commandSubscription) this.commandSubscription.unsubscribe();
  }

  closeDialog(action: DialogCloseAction) {
    console.log('Close dialog action', action);
    this.service.close(this.commandId);
  }
}
